import mutations from './mutations/index'
import getters from './getters/index'
import actions from './actions/index'

// state
const state = {
  isSign: 0,  // 1 代表报名用户

  myUid: 0,
  myInfo: null,  // 我的个人信息

  // 我的进展
  myDetail: null,

  // 实盘数据
  cupInfo: null,

  // playerInfo
  player: null,

  // cupPlayerInfo
  cupPlayer: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
